module.exports = __webpack_public_path__ + "static/media/arrow-black-down.08b85e0f.svg";